<template>
    <div class="cancelplan-root">
        <div class="root-container" v-if="showContent">
            <div class="content-top">
                <h1 >{{ $t('cancel_plan.title', {
                    planname: currentSubscription?.planInfo?.series?.i18n.name
                }) }}</h1>
            </div>
            <steps :stepsData="stepsData" :stepsIndex="highLight" class="step-com"></steps>

            <div class="step-one">
                <sim-plan-display
                    v-if="!!simInfo"
                    :sim-info="simInfo"
                    :sub-id="prevSubId"
                    :refundData="refundArr"
                    :device-info="deviceInfo"
                />
                <p class="package" v-if="mode!=='traffic'">{{ $t('cancel_plan.are_you_sure') }}</p>
                <p class="package" v-else>{{ $t('cancel_plan.traffic.are_you_sure') }}</p>

                <div class="middle-before" v-if="currentSubscription?.planInfo">
                    <p class="package canc-plan">
                        <span class="benefit"> &bull;</span>
                        <span v-html="$t('cancel_plan.take_effect')"></span>
                    </p>
                    <template v-if="mode!=='traffic'">
                        <p class="package canc-plan">
                            <span class="benefit">&bull;</span>
                            <span v-html="$t('cancel_plan.before_cancel')"></span>
                        </p>
                        <section class="benefit-box" v-if="!isAddOnPlan">
                            <p class="info-white three-service" v-if="isCloudDataPlan"><span>&bull;</span> &nbsp; <span>{{ currentSubscriptionDataSize }}</span></p>
                            <p class="info-white three-service" v-if='$options.filters?.planRichNotification(currentSubscription?.planInfo)'><span>&bull;</span> &nbsp; <span v-html="$options.filters.planRichNotification(currentSubscription?.planInfo)"></span></p>
                            <p  class="info-grey three-service" v-if="isCloudPlan"><span>&bull;</span> &nbsp; <span v-html="$options.filters?.planHistory(currentSubscription.planInfo)"></span></p>
                        </section>
                        <template v-if="isCloudDataPlan">
                            <p class="package canc-plan">
                                <span class="benefit">&bull;</span>
                                <span v-html="$t('cancel_plan.notes.title')"></span>
                            </p>
                            <section class="benefit-box">
                                <p
                                    v-for="i in Object.keys(Array(8).fill(0)).map(key=>Number(key)+1)"
                                    :key="i"
                                    class="package canc-plan"
                                    :class="{'red': i === 8}"
                                >
                                    <span class="benefit">&bull;</span>
                                    <span v-html="$t(`cancel_plan.notes.note${i}`)" v-if="i!==5"></span>
                                    <i18n path="cancel_plan.notes.note5" v-else>
                                        <router-link place="checkLink" to="/user/cloud-plan-payment-history/">{{ $t('cancel_plan.notes.checkLink') }}</router-link>
                                    </i18n>
                                </p>
                            </section>
                        </template>
                        <template v-else-if="isAddOnPlan">
                            <p class="package canc-plan">
                                <span class="benefit">&bull;</span>
                                <i18n path="cancel_plan.notes.note5">
                                    <router-link place="checkLink" to="/user/cloud-plan-payment-history/">{{ $t('cancel_plan.notes.checkLink') }}</router-link>
                                </i18n>
                            </p>
                        </template>
                    </template>
                    <template v-else>
                        <p class="package canc-plan">
                            <span class="benefit">&bull;</span>
                            <span>{{$t('cancel_plan.traffic.after_cancel')}}</span>
                        </p>
                    </template>

                </div>
                <div class='middle-cancel-ways' v-if="refundArr.length > 0">
                    <p class="package">{{$t('cancel_plan.select_cancel_way')}}</p>
                    <section class="reasons-box" >
                        <div class="choose-checkbox">
                            <reo-radio class="circle"
                                type="circle"
                                size="small"
                                v-model="cancelWay"
                                label="refund">
                                <span class="info-white">{{$t('cancel_plan.cancel_way_1')}}</span> </reo-radio>
                        </div>
                        <div class="choose-checkbox" v-if="transferableSub.length>0">
                            <reo-radio class="circle"
                                type="circle"
                                size="small"
                                v-model="cancelWay"
                                label="transfer">
                                <span class="info-white">{{$t('cancel_plan.cancel_way_2')}}</span>
                            </reo-radio>
                            <div v-if="transferableSub && cancelWay==='transfer'">
                                <carousel
                                    class='planCarousel'
                                    ref="planChooseCarousel"
                                    :mouseDrag="false"
                                    :margin='20'
                                    :items="isMobile? 1:2">
                                    <div class='planBox'
                                        :class="{active: nextSubId === sub.id}"
                                        v-for="(sub,index) of transferableSub"
                                        :key="sub.id+index.toString()"
                                        @click="nextSubId = sub.id"
                                    >
                                        <reo-radio class="circle"
                                            type="circle"
                                            size="small"
                                            v-model="nextSubId"
                                            :label='sub.id'></reo-radio>
                                        <div class='planContainer'>
                                            <one-line-text class="cloud-title" :text="$options.filters?.planName(sub.planInfo)"/>
                                            <div>
                                                <label>{{ $t("dashboard.valid_time") }}</label>
                                                <span class="time">{{ $options.filters?.planValidTime(sub)}}</span>
                                            </div>
                                            <div id="cameraAssign" class="rel">
                                                <label>{{ $t("dashboard.cameras_assigned") }}</label>
                                                <span class="number"><span class="brand_light">{{sub.associations.filter(device=>device.status==='active').length}}</span>/{{sub.planInfo?.style['cloud_storage.max_device_quantity']}}</span>
                                            </div>
                                            <div>
                                                <label id="storageSpace">{{ $t("dashboard.space") }}</label>
                                                <span class="space-info">({{calcFinalDataStr(sub.usedSpace??0,false,0)}}/{{calcFinalDataStr(sub.planInfo?.style['cloud_storage.space_capacity'] ?? 0,false,0)}})</span>
                                            </div>
                                            <a class='ui-link' @click='subDeviceDataShow = sub.associationDevices;isShowAssociatedDevices = true'><span class="text">{{$t('cancel_plan.check_devices')}}</span><span class="ui-icon icon-icon_arrow-right"></span></a>
                                        </div>
                                    </div>
                                </carousel>
                            </div>
                        </div>
                    </section>
                </div>
                <div class="middle-reasons">
                    <p class="package" v-if="mode!=='traffic'">{{ $t('cancel_plan.cancel_reason') }}</p>
                    <p class="package" v-else>{{ $t('cancel_plan.traffic.cancel_reason') }}</p>
                    <section class="reasons-box" >
                        <div class="choose-checkbox" v-if="!isAddOnPlan">
                            <reo-radio class="circle"
                                type="circle"
                                size="small"
                                v-model="downloadOne"
                                label="Plan price too expensive.">
                                <span class="info-white">{{$t('cancel_plan.traffic.reason_first')}}</span>
                                <router-link class="ui-link" :to='switchPlanPath' v-if="switchable">
                                    <span class="text">{{ $t('cancel_plan.switch_plan')}}</span><span class="ui-icon icon-icon_arrow-right"></span>
                                </router-link>
                            </reo-radio>
                        </div>
                        <div class="choose-checkbox">
                            <reo-radio class="circle"
                                type="circle"
                                size="small"
                                v-model="downloadOne"
                                label="Data included in the plan is not enough.">
                                <span class="info-white">{{$t('cancel_plan.traffic.reason_second')}}</span>
                            </reo-radio>
                        </div>
                        <div class="choose-checkbox">
                            <reo-radio class="circle"
                                type="circle"
                                size="small"
                                v-model="downloadOne"
                                label="Poor network connectivity.">
                                <span class="info-white">{{$t('cancel_plan.traffic.reason_third')}}</span>
                            </reo-radio>
                        </div>
                        <div class="choose-checkbox">
                            <reo-radio class="circle"
                                type="circle"
                                size="small"
                                v-model="downloadOne"
                                label="Technical issues with SIM card activation/usage.">
                                <span class="info-white">{{$t('cancel_plan.traffic.reason_forth')}}</span>
                            </reo-radio>
                        </div>
                        <div class="choose-checkbox">
                            <reo-radio class="circle"
                                type="circle"
                                size="small"
                                v-model="downloadOne"
                                label="No longer needed due to the return of camera.">
                                <span class="info-white">{{$t('cancel_plan.traffic.reason_fifth')}}</span>
                            </reo-radio>
                        </div>
                        <div class="choose-checkbox">
                            <reo-radio class="circle"
                                type="circle"
                                size="small"
                                v-model="downloadOne"
                                label="Accidental purchase.">
                                <span class="info-white">{{$t('cancel_plan.traffic.reason_sixth')}}</span>
                            </reo-radio>
                        </div>
                        <div class="choose-checkbox">
                            <reo-radio class="circle"
                                type="circle"
                                size="small"
                                v-model="downloadOne"
                                label="Other.">
                                <span class="info-white">{{$t('cancel_plan.traffic.reason_seventh')}}</span>
                            </reo-radio>
                        </div>
                    </section>
                </div>
                <div class="middle-text">
                    <p
                        v-if="mode!=='traffic'"
                        v-html="$t('cancel_plan.notice', lang, {
                            link: config.support_team
                        })"
                    ></p>
                    <p
                        v-else
                        v-html="$t('cancel_plan.traffic.notice', lang, {
                            link: config.support_team
                        })"
                    ></p>
                </div>
                <div class="check-ok">
                    <reo-old-checkbox v-model="sureSend" size="small"></reo-old-checkbox>
                    <span class="red">*</span>
                    <span>{{ $t('cancel_plan.got_it') }}</span>
                </div>
                <div class="button-box">
                    <reo-common-button  :label="$t('cancel_plan.no_keep')" @click="$router.push('/user/dashboard/')"/>
                    <reo-common-button
                        colorType="light"
                        :label="$t('cancel_plan.yes_cancel')"
                        @click="continueCancel"
                        :disabled="isCanceling"
                    />
                </div>
            </div>
        </div>
        <InputPaypal
            v-model="showPaypalDialog"
            @confirmInputPaypal="confirmInputPaypal"
        />
        <reo-dialog
            class='associatedDevices'
            title='Associated Devices'
            v-if='isShowAssociatedDevices'
            @cancel='isShowAssociatedDevices=false'
            @dialogMounted='dialogMounted'
            @dialogDestroyed="dialogDestroyed">
            <select-product
                tableLoc="associated"
                key="associatedDevices"
                :deviceData='subDeviceDataShow'>
            </select-product>
        </reo-dialog>
        <reo-dialog
            v-if="showConfirmAddOn"
            :description="$t('cancel_plan.addOnNote')"
            @confirm="confirmAddOn=true;showConfirmAddOn=false; continueCancel()"
            @cancel="cancel"
            :labelOfConfirm="$t('cancel_plan.confirm')"
            :labelOfCancel="$t('cancel_plan.cancel')"
            @dialogMounted='dialogMounted'
            @dialogDestroyed="dialogDestroyed"
        />
    </div>
</template>

<script lang="ts">
import {
    previewRefundInfo,
    transferSubscription
} from '@/api/plan';
import { deleteProduct } from '@/api/subscriptions';

import Carousel from '@/basic/Carousel.vue';
import reoOldCheckbox from '@/basic/Checkbox.vue';
import ReoDialog from '@/basic/Dialog.vue';
import reoRadio from '@/basic/Radio.vue';
import steps from '@/basic/Steps.vue';
import { unfoldError } from '@/common/js/notice';
import { calcFinalDataStr } from '@/common/js/utils';
import OneLineText from '@/components/OneLineText.vue';
import SimPlanDisplay from '../Subscribe/SIMPlan/components/SimPlanDisplay.vue';
import SelectProduct from '@/components/selectProduct.vue';
import { deliver as deliverStatus } from '@/config/status';
import { EDeviceInfoModule, ESeriesCategory, ESimCardModule, ESubscribeMode, ICancelSubscriptionArgs, ICancelSubscriptionPreview, ICloudService, IPlanMessage, ITotalDevice, TCloudDevice } from '@reolink-cloud/interface';

import { productsManager } from '@/lib';
import { uidHandler } from '@/lib/uidHandler';
import { AxiosError } from 'axios';
import { config } from 'CONFIG';
import dayjs from 'dayjs';
import nprogress from 'nprogress';
import Vue from 'vue';
import { RawLocation } from 'vue-router';
import { SimManager } from '@/lib/simManager';
import { getSimCard } from '@/api/sim';
import { getDevice } from '@/api/device';
import InputPaypal from '@/components/InputPaypal.vue';
import { deviceManager } from 'VIEW/checkout/lib/deviceManager';
import { errorUploader } from '@/lib/errorUploader';
import { getPlanDataSizeStr, isValidIccid } from '@/utils/business';
import { getYmhFromQuery } from '@/common/js/query';
import { Optimization } from '@reolink-web/utils';

type TExtendCloudService=ICloudService&{ usedSpace?: number;associationDevices: TCloudDevice[]; };

export default Vue.extend({
    data () {

        return {
            prevSubId: this.$route.query.ps_id as string,
            traffic_package_id: this.$route.query.traffic_package_id as string,
            trafficPlanId: this.$route.query.traffic_plan_id as string,
            mode: this.$route.query.mode,
            downloadOne: '',
            cancelWay: 'refund',
            sureSend: false,
            address: this.$store.state.user.user.email.address,
            sub: {} as Record<string, any>,
            refundArr: [] as ICancelSubscriptionPreview['refund'],
            stepsData: [
                {
                    name: '1',
                    value: 1
                },
                {
                    name: '2',
                    value: 2
                }
            ],
            showContent: false,
            showPaypalDialog: false,
            dialogConfirmShow: false,
            showTips: false,
            loading: false,
            carouselItems: 2,
            planList: [] as any[],
            nextSubId: '',
            nextSub: {} as Record<string, any>,
            transferableSub: [] as TExtendCloudService[],
            dialogStack: [] as any[],
            isShowAssociatedDevices: false,
            subDeviceDataShow: [] as any[],
            config,
            cancelMethod: '',
            paypalDetails: {
                payerAccount: {
                    value: '',
                    placeholder: this.$t( 'cancel_plan.paypal_account' ),
                    required: true,
                    half: false,
                    autocomplete: 'paypal-account',
                    error: false
                }
            },
            payoneerDetails: {
                payoneerName: {
                    value: '',
                    placeholder: this.$t( 'cancel_plan.payoneer_name' ),
                    required: true,
                    half: false,
                    autocomplete: 'payoneer-name',
                    error: false
                },
                payoneerCard: {
                    value: '',
                    placeholder: this.$t( 'cancel_plan.payoneer_card' ),
                    required: true,
                    half: false,
                    autocomplete: 'payoneer-cardNum',
                    error: false
                }
            },
            simInfo: null as null | SimManager,
            deviceInfo: null as ITotalDevice | null,
            calcFinalDataStr,
            showConfirmAddOn: false,
            confirmAddOn: false,
            isCanceling: false
        };

    },

    components: {

        reoOldCheckbox,
        reoRadio,
        steps,
        ReoDialog,
        Carousel,
        SelectProduct,
        SimPlanDisplay,
        OneLineText,
        InputPaypal
    },

    async created () {

        await this.initData();

        nprogress.done();

        this.continueCancel = Optimization.debounce( this.continueCancel, 300 ).bind( this );

    },
    methods: {
        async continueCancel (): Promise<void> {

            let sub = this.sub;
            let isTraffic = this.mode === 'traffic';
            if ( !this.simInfo ) {

                return;

            }
            if ( !isTraffic && sub.status === 'inactive' ) {

                unfoldError( 'errors.plan_not_available' );

            } else if ( !isTraffic && ( sub.status === deliverStatus.PENDING || sub.status === deliverStatus.PROCESSING )) {

                unfoldError( 'errors.sub_processing' );

            } else if ( !this.sureSend || !this.downloadOne ) {

                unfoldError( 'errors.checkbox_required' );

            } else {

                const activeAddOns = this.simInfo.activeAddOns;
                if ( this.cancelWay === 'transfer' ) {

                    let planData: Record<string, any> = {};
                    planData.productId = this.nextSub.planInfo.id;
                    planData.qty = 0;
                    planData.context = {
                        action: 'transfer',
                        subscription: this.prevSubId,
                        toSubscription: this.nextSubId
                    };
                    let data: Record<string, any> = {};
                    data.items = [planData];
                    data.amount = '0.00';
                    data.currency = this.refundArr[0].currency;
                    try {

                        let res = await transferSubscription( data );
                        if ( this.isCloudDataPlan ) {

                            for ( const addOn of activeAddOns ) {

                                planData.context.subscription = addOn.id;
                                await transferSubscription( data );

                            }

                        }
                        await this.$router.push({
                            path: `/user/complete/`,
                            query: {
                                mode: 'transfer',
                                id: res.id
                            }
                        });

                    } catch ( err ) {

                        console.log( err );
                        let symbol = ( err as AxiosError ).response?.data.error.symbol;
                        let reason = typeof ( err as AxiosError ).response?.data.error.metadata.reason !== 'undefined' ? ( err as AxiosError ).response?.data.error.metadata.reason : '';
                        let key = '';
                        if ( symbol === 'violate_subscribe_restriction' ) {

                            if ( reason === 'subscriptionMaxPurchaseCycles' ) {

                                key = 'errors.violate_cycle_limitation';

                            }

                        } else if ( symbol === 'cannot_cancel_subscription' ) {

                            if ( reason === 'service is refunding' ) {

                                key = 'errors.service_refunding';

                            }

                        } else if ( symbol === 'usr_locked' ) {

                            key = 'errors.usr_locked';
                            if ( reason === 'user locked for auto-renew' ) {

                                key = 'errors.user_locked_for_auto-renew';

                            }

                        } else if ( symbol === 'upgrade_maintenance' ) {

                            key = 'errors.service_maintenance';

                        }
                        this.loading = false;
                        unfoldError( key, 10000 );

                    }
                    return;

                }
                this.loading = true;
                this.isCanceling = true;

                try {

                    if ( this.dialogConfirmShow ) {

                        ( this.$refs.confirmDialog as any )?.disabledBtn();

                    }
                    if ( this.checkIfNeedPaypal()) {

                        this.showPaypalDialog = true;
                        return;

                    }

                    await deleteProduct( this.generateChooseRadioObj( this.prevSubId ));

                    await this.$router.push({

                        path: '/user/cancel-plan/complete/',
                        query: {
                            plan_name: sub.plan.title,
                            type: isTraffic ? 'traffic' : 'storage'
                        }

                    });

                } catch ( err ) {

                    const symbol = ( err as AxiosError ).response?.data.error.symbol;
                    if ( this.dialogConfirmShow && ( this.$refs.confirmDialog as any )?.confirmDisabled ) {

                        ( this.$refs.confirmDialog as any )?.enabledBtn();

                    }
                    if (( err as AxiosError ).response?.data.error.symbol === 'cannot_update_refund' ) {

                        unfoldError( 'errors.cannot_update_refund' );
                        this.showPaypalDialog = false;

                    } else if (( err as AxiosError ).response?.data.error.symbol === 'payer_account_required' ) {

                        this.showPaypalDialog = true;
                        // if ( config.oem !== 'reolink' ) {

                        this.cancelMethod = 'Paypal';

                        // } else {

                        //     this.$nextTick(() => {

                        //         this.$refs.paypalDialog.disabledBtn();

                        //     });

                        // }

                    } else if (( err as AxiosError ).response?.data.error.symbol === 'cannot_cancel_subscription' ) {

                        this.showPaypalDialog = false;
                        let reason = ( err as AxiosError ).response?.data.error?.metadata?.reason ?? '';
                        if ( reason === 'subscription inactive' ) {

                            unfoldError( 'cancel_plan.cancelled', 10000 );
                            setTimeout(() => {

                                this.$router.push({ path: '/user/dashboard' }).catch( console.error );

                            }, 5000 );

                        } else if ( reason === 'service is refunding' || reason === 'subscription is refunding' ) {

                            unfoldError( 'errors.service_refunding', 10000 );

                        } else {

                            unfoldError( 'errors.server_error', 10000 );

                        }

                    } else if (( err as AxiosError ).response?.data.error.symbol === 'cannot_cancel_package' ) {

                        let reason = ( err as AxiosError ).response?.data.error.metadata.reason ?? '';

                        // package inactive
                        if ( reason === 'package inactive' ) {

                            unfoldError( 'errors.package_inactive', 10000 );
                            setTimeout(() => {

                                this.$router.push({ path: '/user/dashboard/?mode=view' }).catch( console.error );

                            }, 5000 );

                        } else if ( reason === 'package is refunding' ) {

                            unfoldError( 'errors.order_not_refundable', 10000 );

                        }

                    } else if (( err as AxiosError ).response?.data.error.symbol === 'duplicate_manual_refund' ) {

                        unfoldError( 'errors.order_not_refundable', 10000 );

                    } else if ( symbol === 'usr_locked' ) {

                        unfoldError( 'errors.usr_locked' );

                    } else if ( symbol === 'upgrade_maintenance' ) {

                        unfoldError( 'errors.service_maintenance' );

                    } else {

                        unfoldError( 'errors.server_error' );
                        this.showPaypalDialog = false;
                        this.showTips = false;
                        this.loading = false;
                        console.error( err );

                    }
                    errorUploader.uploadCancelPlanError( err );

                } finally {

                    this.isCanceling = false;

                }

            }

        },
        generateChooseRadioObj( id: string ) {

            let chooseRadioObj: ICancelSubscriptionArgs = {
                id,
                reason: this.downloadOne
            };

            if ( this.cancelMethod === 'Paypal' ) {

                chooseRadioObj.manualRefundInfo = {
                    method: 'paypal',
                    account: this.paypalDetails.payerAccount.value
                };

            } else if ( this.cancelMethod === 'Payoneer' ) {

                chooseRadioObj.manualRefundInfo = {
                    method: 'payoneer',
                    number: this.payoneerDetails.payoneerCard.value,
                    holderName: this.payoneerDetails.payoneerName.value
                };

            }

            chooseRadioObj = JSON.parse( JSON.stringify( chooseRadioObj ));

            return chooseRadioObj;

        },
        async initData (): Promise<void> {

            try {

                await productsManager.update({ lang: this.lang });
                const [ refundData] = await Promise.all( [
                    previewRefundInfo( this.prevSubId )
                ] );

                this.refundArr = refundData.refund;

                // for ( const sub of subs ) {

                //     const associatedDevices = sub.associations.map( association => deviceList.find( device => association.uid === device.uid ));

                //     if ( associatedDevices.some( device => device?.status === EAccountDeviceStatus.BOUND ) &&  sub.type !== 'package' ) {

                //         if ( parseFloat( sub.planInfo?.pricing.salePrice ?? '0' ) !== 0 && sub.id !== this.prevSubId ) {

                //             const activeAssociatedUids = sub.associations.filter( association => association.status === 'active' && 'uid' in association ).map( device => device.uid );
                //             const usageRes = await getUserUsage( activeAssociatedUids );
                //             let usedSpace = 0;
                //             for ( const item of usageRes.items ) {

                //                 usedSpace += item.usedSpace;

                //             }
                //             this.transferableSub.push({ ...sub, usedSpace, associationDevices: deviceList.filter( device => activeAssociatedUids.includes( device.uid )) });

                //         }

                //     }

                // }
                this.nextSubId = this.transferableSub.length > 0 ? this.transferableSub[0].id : '';

                const prevSubId = this.prevSubId;
                const iccidOrUid = getYmhFromQuery( this.$route );
                if ( iccidOrUid && prevSubId ) {

                    if ( isValidIccid( iccidOrUid )) {

                        const rawSimData = await getSimCard({ iccid: iccidOrUid, includes: [ESimCardModule.CLOUD_SERVICES, ESimCardModule.SIM_CARD], lang: this.lang });
                        const simManager = new SimManager( rawSimData, rawSimData.services );
                        await simManager.init();
                        await deviceManager.init( [], [ 'bound', 'unbound' ] );

                        this.simInfo = simManager;

                    } else {

                        const deviceRes = await getDevice({
                            owner: String( this.$store.state.user.user.id ),
                            uid: iccidOrUid,
                            includes: [EDeviceInfoModule.CLOUDSERVICES, EDeviceInfoModule.MODEL, EDeviceInfoModule.SIMCARD],
                            lang: this.lang,
                        });
                        const svcRecord = deviceRes.services ?? {};
                        if ( Object.keys( svcRecord ).length > 0 ) {

                            this.deviceInfo = {
                                uid: deviceRes.uid,
                                model: deviceRes.model?.title ?? '',
                                modelTitle: deviceRes.model?.title ?? '',
                                modelId: 0,
                                title: deviceRes.model?.title ?? '',
                                plan: '',
                                subscription: '',
                                status: 'unassociated',
                                videoRetentionDays: 0,
                                associatedAt: 0,
                                unassociatedAt: 0,
                                features: {},
                                boundStatus: 'unbound',
                            } as ITotalDevice;
                            const simManager = new SimManager(
                                {
                                    cloudServices: deviceRes.cloudServices ?? Object.keys( svcRecord ),
                                    simCard: deviceRes.simCard ?? undefined,
                                    esimDevice: '',
                                } as any,
                                svcRecord,
                            );
                            await simManager.init();
                            this.simInfo = simManager;

                        }

                    }

                }

                if ( this.currentSubscription ) {

                    this.sub = this.currentSubscription;

                } else {

                    throw new Error( 'Subscription not found!' );

                }

                this.showContent = true;

            } catch ( err ) {

                this.loading = true;
                let symbol = ( err as AxiosError ).response?.data.error.symbol;

                if ( symbol === 'cannot_cancel_subscription' ) {

                    let reason = typeof ( err as AxiosError ).response?.data.error.metadata.reason !== 'undefined' ? ( err as AxiosError ).response?.data.error.metadata.reason : '';

                    // subscription inactive
                    if ( reason === 'subscription inactive' ) {

                        unfoldError( 'cancel_plan.cancelled', 10000 );
                        setTimeout(() => {

                            this.$router.push({ path: '/user/dashboard' }).catch( console.error );

                        }, 5000 );

                    } else if ( reason === 'service is refunding' ) {

                        unfoldError( 'errors.service_refunding', 10000 );

                    } else {

                        unfoldError( 'errors.server_error', 10000 );

                    }

                } else if ( symbol === 'order_not_refundable' ) {

                    unfoldError( 'errors.order_not_refundable', 10000 );

                } else if ( symbol === 'upgrade_maintenance' ) {

                    unfoldError( 'errors.service_maintenance', 10000 );

                } else {

                    this.loading = false;
                    console.error( err );
                    unfoldError( 'errors.server_error', 10000 );

                }
                errorUploader.uploadCancelPlanError( err );
                nprogress.done();

            }

        },
        dialogMounted ( ref: any ): void {

            if ( this.dialogStack.length === 0 ) {

                $( $( 'html' )[0] ).toggleClass( 'dialogActivated' );

            }
            this.dialogStack.push( ref );

        },
        dialogDestroyed ( ): void {

            this.dialogStack.pop();
            if ( this.dialogStack.length === 0 ) {

                $( $( 'html' )[0] ).toggleClass( 'dialogActivated' );

            }

        },
        showFormError ( cancelMethod: string ): boolean {

            const group = cancelMethod === 'Payoneer' ? this.payoneerDetails : this.paypalDetails;
            let showError = false;
            for ( let key in group ) {

                let item = group[key];
                if ( item.required ) {

                    if ( !item.value || item.value === '' ) {

                        item.error = this.$tc( 'errors.field_required' );
                        showError = true;

                    }
                    if ( item.value.length > 255 ) {

                        item.error = this.$tc( 'errors.common_length_error', undefined, { option: item.placeholder });
                        showError = true;

                    }

                }

            }
            return showError;

        },
        showConfirmDialog (): void {

            if ( this.showPaypalDialog && this.showFormError( this.cancelMethod )) {

                return;

            }
            this.dialogConfirmShow = true;
            this.showPaypalDialog = false;

        },
        cancel (): void {

            this.showPaypalDialog = false;
            this.dialogConfirmShow = false;
            this.showConfirmAddOn = false;
            this.loading = false;
            this.cancelMethod = '';
            this.paypalDetails.payerAccount.value = '';
            this.payoneerDetails.payoneerCard.value = '';
            this.payoneerDetails.payoneerName.value = '';

        },
        async confirmInputPaypal( account: string ) {

            this.paypalDetails.payerAccount.value = account;
            await this.continueCancel();

        },
        checkIfNeedPaypal (): boolean {

            return this.cancelMethod === 'Paypal' && this.paypalDetails.payerAccount.value === '';

        }

    },
    watch: {
        cancelWay: {
            handler ( newVal ) {

                if ( newVal === 'transfer' ) {

                    if ( this.isMobile ) {

                        this.carouselItems = 1;

                    } else {

                        this.carouselItems = 2;

                    }
                    this.$nextTick(() => {

                        ( this.$refs.planChooseCarousel as any ).init();

                    });

                }

            },
            immediate: true
        },
        nextSubId: {
            handler ( newVal ) {

                for ( let sub of this.transferableSub ) {

                    if ( sub.id === newVal ) {

                        this.nextSub = sub;

                    }

                }

            },
            immediate: true
        },
        cancelMethod ( newVal ) {

            if ( newVal === 'Payoneer' ) {

                this.paypalDetails.payerAccount.required = true;
                this.paypalDetails.payerAccount.error = false;

            } else {

                this.payoneerDetails.payoneerCard.required = true;
                this.payoneerDetails.payoneerName.required = true;
                this.payoneerDetails.payoneerCard.error = false;
                this.payoneerDetails.payoneerName.error = false;

            }

            if (( this.$refs.paypalDialog as any )?.confirmDisabled ) {

                ( this.$refs.paypalDialog as any )?.enabledBtn();

            }

        }
    },
    computed: {

        highLight () {

            let { path } = this.$route;
            return path === '/user/cancel-plan/complete/' ? 1 : 0;

        },

        message (): IPlanMessage[] {

            let sub = this.sub;
            let refundArr = this.refundArr;
            let result = [
                {
                    label: this.$tc( 'cancel_plan.account' ),
                    texts: [
                        this.address
                    ],
                    red: true
                }

            ];
            if ( this.mode === 'traffic' ) {

                result.push({
                    label: this.$tc( 'cancel_plan.current_plan' ),
                    texts: [
                        this.sub.plan.title
                    ],
                    red: true
                });

            } else {

                result.push({
                    label: this.$tc( 'cancel_plan.current_plan' ),
                    texts: [
                        this.$options.filters!.planName( sub.plan )
                    ],
                    red: true
                });

            }

            if ( refundArr && refundArr.length > 0 ) {

                let refundText = refundArr.map(( item ) => {

                    return `${item.currency} ${item.value}`;

                }).join( ' + ' );

                result.push({

                    label: this.$tc( 'cancel_plan.refund' ),
                    texts: [
                        refundText
                    ],
                    red: true

                });

            }

            return result;

        },

        switchPlanPath (): RawLocation {

            return {
                path: '/user/subscribe-plan/sim/choose',
                query: {
                    ymh: uidHandler.encrypt( this.simInfo?.iccid ?? '' ),
                    s_id: this.currentSubscription?.id,
                    mode: ESubscribeMode.SWITCH,
                    subExpired: this.currentSubscription?.effectiveStatus === 'inactive' ? '1' : undefined
                }
            };

        },

        isMobile(): boolean {

            return this.$store.getters.isMobile;

        },
        lang(): string  {

            return this.$store.getters.lang;

        },
        client (): string {

            return this.config.oem;

        },
        currentSubscription(): ICloudService|undefined {

            return this.simInfo?.serviceArr.find( item => item.id == this.prevSubId );

        },
        currentSubscriptionDataSize(): string {

            return getPlanDataSizeStr( this.currentSubscription?.planInfo, this.$i18n );

        },
        isCloudPlan(): boolean {

            return [ESeriesCategory.CLOUD_STORAGE_PLAN, ESeriesCategory.CLOUD_STORAGE_DATA_PLAN].includes( this.currentSubscription?.planInfo?.series?.category as ESeriesCategory );

        },
        isCloudDataPlan(): boolean {

            return [ESeriesCategory.CLOUD_DATA_PLAN, ESeriesCategory.CLOUD_STORAGE_DATA_PLAN].includes( this.currentSubscription?.planInfo?.series?.category as ESeriesCategory );

        },
        isAddOnPlan(): boolean {

            return this.currentSubscription?.planInfo?.series?.category === ESeriesCategory.CLOUD_DATA_ADD_ON_PLAN;

        },
        switchable(): boolean {

            return this.currentSubscription?.nextSwitchableAt !== 0
            && dayjs().valueOf() > ( this.currentSubscription?.nextSwitchableAt ?? Infinity );

        },
        isLocked(): boolean {

            return !!this.simInfo?.data.esimDevice;

        }

    }

});
</script>

<style lang="less" scoped>
    .cancelplan-root {
        margin: auto;
        max-width: 1200px;
        padding-top: 78px;
        padding-bottom: 160px;
        background-color:@bg_02;
        border-radius: 12px;
        font-family: @font_02;
        color: @font_primary;
        .root-container{
            @media @pc{
                margin: 0 220px;
            }
        }
        .content-top {
            text-align: center;
            h1 {
                padding-bottom: 33px;
                font-size: 36px;
                font-weight: 500;
                line-height: normal;
                text-align: center;
                letter-spacing: 0em;
                color: @font_primary;
                font-family: @font_01;
            }
        }

        /deep/ .sim-plan-display{
            .plan-shell{
                padding: 0;
                padding-bottom: 20px;
            }
        }

    }
    .step-com{
        margin-bottom: 49px;
    }
    .middle-content {
        margin-bottom: 50px;
        /deep/ .sim-plan-display{
            background-color: @bg_03;
        }
        & /deep/ .plan-message{
            @media @pc{
                padding:.32rem .56rem;
            }
            tr+tr td{
                padding-top: 0.16rem;
                @media @mobile{
                    padding-top: 0.2rem;
                }
            }
        }
    }
    .package {
        margin-bottom: 15px;
        font-size: 22px;
        font-weight: 500;
        line-height: normal;
        letter-spacing: 0em;
    }

    .package.canc-plan{
        margin-bottom: 14px;
        font-weight: normal;
        font-size: 16px;
        display: flex;
        .benefit{
            padding-right:0.15rem;;
        }
    }
    .middle-cancel-ways{
        margin-bottom: 58px;
        .planCarousel{
            margin-top: 20px;
        }
        .planBox{
            display: flex;
            // box-sizing: border-box;
            border:1px solid @line;
            padding:32px 44px;
            cursor: pointer;
            @media @mobile{
                padding: 15px 27px;
            }
            &.active{
                border-color: @brand_light
            }
            .circle{
                padding-top: 4px;
            }
            .planContainer{
                font-size: 16px;
                font-weight: normal;
                margin-left: 17px;
                width: 100%;
                @media @mobile {
                    font-size: 12px;
                    width: calc(100% - 17px)
                }
                &>div{
                    margin-bottom: 20px;
                    @media @mobile{
                        margin-bottom: 10px;
                    }
                }
                label{
                    font-weight: 500;
                    margin-right: 10px;
                }
                .ui-link{
                    .text{
                        @media @mobile{
                            font-size: 12px;
                        }
                    }
                    .ui-icon{
                        @media @mobile{
                            font-size: 10px;
                        }
                    }
                }
                .brand_light{
                    color: @brand_light;
                }
                .cloud-title{
                    display: flex;
                    align-items: center;
                    font-weight: 500;
                    @media @mobile{
                        font-size: 16px;
                    }
                    i{
                        display: inline-block;
                        width: 14px;
                        height: 14px;
                        border-radius: 50%;
                        margin-right: 8px;
                        vertical-align: bottom;
                        position: relative;
                        @media @mobile{
                            width: .24rem;
                            height: .24rem;
                        }
                    }
                }
            }

        }
    }
    .middle-before {
        padding: 30px;
        background: @bg_03;
        margin-bottom: 51px;
        border-radius: 12px;
    }
    .benefit-box {
        margin-left:0.2rem;
        padding-bottom: 0.1rem;
        .three-service+.three-service{
            margin-top: 0.08rem;
        }
    }
    .middle-reasons {
        margin-bottom: 18.5px;
        padding-bottom: 47.9px;
        border-bottom: solid 1px @line;
        .package {
            &::before {
                content: '*';
                color: #e74330;
                margin-right: 0.04rem;
                font-size: 0.16rem;
            }
        }
    }
    .reasons-box {
       .info-white {
            color: @font_primary;
            font-size: 16px;
            font-weight: 500;
            margin-right: 10px;
            line-height: normal;
            white-space: wrap;
        }
    }
    .reasons-right {
        margin-left:0.4rem;
        position: relative;
        top:0.02rem;
        a {
            .text {
                font-weight: 500;
                font-size: 0.16rem;
            }
        }
    }
    .choose-checkbox {
        // display: flex;
        &:nth-child(n+2){
            margin-top: 12px;
        }
    }
    .middle-text {
        p {
            font-size: 16px;
            font-weight: normal;
            line-height: normal;
        /deep/ a {
            color: @brand_light;
            cursor: pointer;
            font-size: 16px;
        }
      }
    }
    .check-ok {
        margin: 16px 0 36.4px 0;
        .checkbox-wrap-container{
            margin-right: 0.1rem;
        }
        span {
            font-weight: 500;
            font-size: 16px;
            font-weight: 500;
            vertical-align: middle;
        }
    }
    .button-box {
        text-align: center;
        justify-content: center;
        display: flex;
        gap: 20px;
    }
    @media @mobile{
        .cancelplan-root {
            padding: 0 15px;
            background-color: transparent;
            .root-container{
               width:100%;
            }
            .content-top {
                h1 {
                    margin-top: 30px;
                    margin-bottom: 20px;
                    font-weight: normal;
                    font-size: 20px;
                    padding:0;
                }
            }
            .step-com{
                margin-bottom: 58px;
            }
        }
        .middle-content {
            padding-bottom: 30px;
            margin-bottom:0;
        }
        .package {
            font-weight: bold;
            font-size: 20px;
            margin-bottom: 10px;
        }
        .package.canc-plan{
            margin-bottom: 0.12rem;
            font-weight: 400;
            font-size: 0.26rem;
            display: flex;
            .benefit{
                padding-right:0.15rem;
            }
        }

        .middle-before {
            padding: 15px;
            margin-bottom: 30px;
        }
        .benefit-box {
            line-height: normal;
            .info-white {
                font-size: 14px;
                font-weight: normal;
            }
            .three-service+.three-service{
                margin-top: 0.1rem;
            }
        }
        .middle-reasons {
            padding-bottom: 30px;
            margin-bottom: 30px;
            .package {
                &::before {
                    content: '*';
                    color: #e74330;
                    margin-right: 0.04rem;
                    font-size: 0.28rem;
                }
            }
        }
        .reasons-box {
            .info-white {
                font-size: 14px;
                color: @font_primary;
            }
        }
        .reasons-right {
            margin-left:0;
            position: relative;
            margin-left:0.2rem;
            a {
                .text {
                    font-weight: 500;
                    font-size: 0.26rem;
                }
            }
        }
        .middle-text {
            p {
                font-size: 12px;
                font-weight: normal;
                /deep/ a.ui-link {
                    color: @brand_light;
                    cursor: pointer;
                    font-weight: 500;
                    font-size: 12px;
                }
            }
        }
        .check-ok {
            margin: 10px 0 50px 0;
            span.red{
                margin-left:0.1rem;
            }
            span {
                font-weight: 500;
                font-size: 0.26rem;
            }
        }
        .button-box {
            display: flex;
            margin:0;
            margin-bottom: 70px;
            flex-direction: column;
            gap: 10px;
            .ui-button{
                width: 100%;
                padding: 0;
            }
            .ui-button:first-child:hover{
                line-height: calc(.78rem + 2px);
            }
            .ui-button+.ui-button{
                margin: 0.2rem 0 0;
            }
        }
    }

    .reo-vfx-area {
        display: inline-block;
        width: 100%;
        margin-bottom: 20px;

        &.half-width {
            width: calc((100% - 20px) / 2);

            &:nth-child(even) {
                margin-left: 20px;
            }
        }

        .reo-vfx-box {
            position: relative;
            display: block;
        }

        .reo-vfx-input {
            font-weight: 500;
            color: @white;
            font-size: 16px;
            padding: 0 20px;
            width: 100%;
            height: 48px;
            line-height: 48px;
            box-sizing: border-box;
            box-shadow: none;
            outline: none;
            border: 1px solid @white;
            background-color: transparent;
            @media @mobile {
                font-size: .28rem;
            }

            &:focus {
                background-color: transparent;
                border-color: @brand_light;
            }
            &.error {
                border-color: @error;
            }

        }

        .reo-vfx-placeholder {
            white-space: nowrap;
            transition: all 0.3s ease-in-out;
            position: absolute;
            top: 50%;
            left: 20px;
            transform: translateY(-50%);
            pointer-events: none;
            font-size: 16px;
            font-weight: 500;
            display: inline-block;
            padding: 0 4px;
            color: @font_fourth;
            @media @mobile {
                font-size: .28rem;
            }
        }

        .reo-vfx-input:focus ~ .reo-vfx-placeholder,
        .reo-vfx-input:not(.empty) ~ .reo-vfx-placeholder {
            top: 0;
            font-size: 14px;
            color: @brand_lightest;
            background-color: @bg_02;
            @media @mobile {
                font-size: .24rem;
            }
        }

        .reo-vfx-input:focus ~ .reo-vfx-placeholder {
            color: @brand_lightest;
        }

        .reo-vfx-required-flag {
            position: absolute;
            top: 0;
            right: -10px;
            color: #e74330;
            font-weight: 500;
            font-size: 18px;
        }

        .input-tip {
            font-size: 14px;
            color: #777;
            font-weight: 500;
            line-height: 1.2;
            margin-top: 16px;
        }
    }
    @media @mobile {
        .reo-vfx-area.half-width[name='postalCode'] {
            margin-left: 0;
            width: 100%;
        }
    }

    .ui-link{
        display: inline-flex;
        align-items: center;
    }
</style>
